export const ruleCarrying = ({ order_type, delivery, skipCarrying }) => {
  if(skipCarrying) return false;
  if (order_type == "dpd") return true;
  if (order_type == "own_transport") return true;
  if (order_type === "venipak" && delivery == "venipak_home") return true;
  return false;
};
